import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import { getLoginStatus } from 'store/apiStatus';
import { loginRequest } from 'store/auth';

import { LoginLayout, LoginEmail } from 'components';

export const LoginEmailContainer = ({ t, status, onLogin }) => (
  <LoginLayout title={t('login.title')} description={t('login.description')}>
    <LoginEmail status={status} onLogin={onLogin} />

    <Link to="/">{t('login.services.title')}</Link>
  </LoginLayout>
);

LoginEmailContainer.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.object.isRequired,
  onLogin: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  status: getLoginStatus(state)
});

const mapDispatchToProps = {
  onLogin: loginRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(LoginEmailContainer)
);



// WEBPACK FOOTER //
// ./src/containers/LoginEmailContainer/LoginEmailContainer.js